module.exports = __webpack_public_path__ + "img/anatomy1.9a4bc110.jpg";